
import { ChevronLeftIcon, ChevronRightIcon, ArrowDownTrayIcon } from "@heroicons/vue/24/solid";
import { defineComponent, PropType } from "vue";
import CalendarDayItem from "@/components/calendar/CalendarDayItem.vue";
import { OverviewItem } from "@/types/DailyReport";

export default defineComponent({
  emits: ["nextMonth", "prevMonth", "resetPag", "bulkExport", "initializeReport", "deleteReport"],
  props: {
    days: {
      type: Array as PropType<OverviewItem[]>,
      required: true,
    },
    currentMonth: {
      type: Number,
      required: true,
    },
    currentYear: {
      type: Number,
      required: true,
    },
  },
  components: {
    CalendarDayItem,
    ChevronLeftIcon,
    ChevronRightIcon,
    ArrowDownTrayIcon,
  },
  computed: {
    weeksVisible() {
      const weeks = this.days.length / 7;
      return weeks;
    },
  },
});
